import React, { useState, useEffect, useLayoutEffect, useContext } from 'react'
import { format } from 'date-fns'

import { Button } from '@leasequery/lq.react-component-library'
import { ReactComponent as Add } from '../../assets/add.svg'
import PaymentInput from './PaymentInput'
import PaymentSchedule from './PaymentSchedule'
import { PaymentContext } from '../../context/PaymentContext'
import { getPaymentSchedules } from '../../utils/FetchRequests'

import './PaymentBuilder.css'

export default function PaymentBuilder({
	navigateForward,
	navigateBack,
	definition,
	value,
}) {
	const ritDataString = sessionStorage.getItem('rit-questions')
	const ritDataObj = JSON.parse(ritDataString)
	const startDate = ritDataObj['2']['answer']
	const endDate = ritDataObj['2']['subAnswer']
	const formatStart = format(new Date(startDate), 'MMMM do, yyyy')
	const formatEnd = format(new Date(endDate), 'MMMM do, yyyy')
	const fairValue = ritDataObj['3']['answer']
	const storedInputs = ritDataObj['4']['answer']

	const [payments, setPayments] = useContext(PaymentContext)
	const [paymentData, setPaymentData] = useState([])
	const [showPayments, setShowPayments] = useState(false)
	const [inputData, setInputData] = useState(value ? value : [])
	const [paymentInputs, setPaymentInputs] = useState([])
	const [advance, setAdvance] = useState(false)
	const [trigger, setTrigger] = useState(false)
	const [valueTracker, setValueTracker] = useState([false])
	const [loading, setLoading] = useState(true)
	const [fetch, setFetch] = useState(false)
	const [jsonObjs, setJsonObjs] = useState([])
	const [success, setSuccess] = useState(true)

	function handleAddPaymentInput() {
		setPaymentInputs([...paymentInputs, <PaymentInput />])
		setValueTracker([...valueTracker, false])
		setShowPayments(false)
		setAdvance(false)
	}

	async function handleRemovePaymentInput(id) {
		let filteredInputs = paymentInputs.filter(
			(x) => paymentInputs.indexOf(x) !== id
		)
		setPaymentInputs(filteredInputs)

		valueTracker.splice(id, 1)

		let removePayments = payments.filter((x) => payments.indexOf(x) !== id)
		setPayments(removePayments)

		let removePaymentData = paymentData.filter(
			(x) => paymentData.indexOf(x) !== id
		)
		setPaymentData(removePaymentData)

		let removeJsonObjs = jsonObjs.filter((x) => jsonObjs.indexOf(x) !== id)
		setJsonObjs(removeJsonObjs)

		let removeInputData = inputData.filter((x) => inputData.indexOf(x) !== id)
		setInputData(removeInputData)

		if (value) {
			value.splice(id, 1)
		}

		setAdvance(false)
		setShowPayments(false)
	}

	function updateValueTracker(id, value) {
		let currentValue = valueTracker
		if (value === currentValue[id]) {
			return
		} else {
			currentValue[id] = value
			setValueTracker(currentValue)
		}
	}

	function checkValues() {
		if (!success) {
			return
		}

		let verify = valueTracker.filter((value) => value === false)

		if (verify.length === 0) {
			setShowPayments(!showPayments)
			setAdvance(true)
			return
		}
		setShowPayments(false)
		setAdvance(false)
	}

	useEffect(() => {
		if (!storedInputs) {
			setPaymentInputs([<PaymentInput />])
		} else {
			setPaymentInputs(storedInputs)
			setFetch(true)
			setAdvance(true)
		}
	}, [])

	useEffect(() => {
		if (jsonObjs.length !== 0 || jsonObjs.length === inputData.length) {
			setFetch(true)
		}
	}, [jsonObjs.length, inputData.length])

	useLayoutEffect(() => {
		if (paymentInputs.length === 0) {
			setPaymentInputs([<PaymentInput />])
		}
	}, [paymentInputs])

	let fetches = []
	let fetchVars = []

	async function fetchPayments() {
		setPaymentData([])
		setPayments([])
		buildFetches()
		const fetchVars = await Promise.all(fetches)
		if (fetchVars[0] === 'error') {
			setShowPayments(false)
			setAdvance(false)
			setSuccess(false)
			return
		} else {
			setPaymentData(fetchVars)
			setPayments(fetchVars)
			setSuccess(true)
			setLoading(false)
		}
	}

	function buildFetches() {
		jsonObjs.forEach((jsonObj, index) => {
			fetches.push(getPaymentSchedules(jsonObj))
			fetchVars.push(`paymentString${index}`)
		})
	}

	async function handleNavigate() {
		navigateForward(inputData)
	}

	async function handlePaymentSchedules() {
		await setTrigger(true)
		if (fetch) {
			fetchPayments()
		}
	}

	return (
		<>
			<div className='payment-container'>
				<div className='banner'>
					<h3>Lease Start: {formatStart}</h3>
					<h3>Lease End: {formatEnd}</h3>
				</div>
				<div className='content'>
					{paymentInputs.map((_data, index) => {
						return (
							<PaymentInput
								handleRemovePaymentInput={handleRemovePaymentInput}
								key={index}
								index={index}
								definition={definition}
								value={value}
								inputData={inputData}
								setInputData={setInputData}
								trigger={trigger}
								setTrigger={setTrigger}
								startDate={startDate}
								endDate={endDate}
								setAdvance={setAdvance}
								updateValueTracker={updateValueTracker}
								checkValues={checkValues}
								fairValue={fairValue}
								setLoading={setLoading}
								setShowPayments={setShowPayments}
								jsonObjs={jsonObjs}
								setJsonObjs={setJsonObjs}
							/>
						)
					})}
					<div className='add'>
						<Add onClick={() => handleAddPaymentInput()} />
						<span
							className='padding-left'
							onClick={() => handleAddPaymentInput()}
						>
							Add More
						</span>
					</div>
				</div>
			</div>
			<div className='see-payment-schedule'>
				<div
					className={
						showPayments && success
							? 'payment-schedule-button-gray hover'
							: 'payment-schedule-button-blue hover'
					}
					onClick={() => handlePaymentSchedules()}
				>
					{showPayments && success ? (
						<span>Hide Payment Schedule</span>
					) : (
						<span>See Payment Schedule</span>
					)}
				</div>
			</div>
			{showPayments && success ? (
				<PaymentSchedule
					paymentData={paymentData}
					loading={loading}
					inputData={inputData}
				/>
			) : null}
			<div>
				<Button
					buttonType='secondary'
					className='form-Button'
					onClick={() => navigateBack()}
				>
					Back
				</Button>
				{advance ? (
					<Button
						buttonType='primary'
						className='form-Button'
						onClick={() => handleNavigate()}
					>
						Next
					</Button>
				) : (
					<></>
				)}
			</div>
		</>
	)
}
